export default __webpack_public_path__ + "static/media/MARKETING_ADVERTISING.4bd5d80d.png";